import Icon from "@Components/generic/icon";
import { faCheck, faHandFist } from "@fortawesome/pro-solid-svg-icons";
import { Alert, Snackbar, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface ITrainingPlansSnackbar {
  open: boolean;
  title: string;
  message: string;
  isComplete: boolean;
  onClose: () => void;
}

const TrainingPlansSnackbar = ({ open, title, message, isComplete, onClose }: ITrainingPlansSnackbar) => {
  const theme = useTheme();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
      open={open}
      onClose={onClose}
      sx={{ top: theme.spacing(3) }}
    >
      <Alert
        icon={
          <Icon
            color={
              isComplete
                ? (theme.palette.dsAmber?.v100 ?? theme.palette.dsOrange?.v200 ?? theme.palette.dsPrimary.v300)
                : theme.palette.dsSuccess.v300
            }
            icon={isComplete ? faHandFist : faCheck}
          />
        }
        onClose={onClose}
        severity="info"
        sx={{
          alignItems: "center",
          background: `linear-gradient(90deg, ${alpha(theme.palette.dsSurface.v200, 0.92)} 0%, ${alpha(theme.palette.dsSurface.v200, 0.92)} 75%, ${alpha(
            theme.palette.dsBrandBlue?.v200 ?? theme.palette.dsPrimary.v300,
            0.92
          )} 100%)`,
          border: `1px solid ${alpha(theme.palette.dsBase.v200, 0.04)}`,
          borderRadius: theme.spacing(2),
          minWidth: theme.spacing(35),
        }}
      >
        <Stack spacing={0.25}>
          <Typography variant="textBase600" color="dsBase.v200">
            {title}
          </Typography>
          <Typography variant="textS500" color="text.secondary">
            {message}
          </Typography>
        </Stack>
      </Alert>
    </Snackbar>
  );
};

export default TrainingPlansSnackbar;
